import { $ } from '@/libs/jquery/index'
import { moment } from '@/libs/moment'

$.validator.addMethod('ischild', function(value: string, element: HTMLElement): boolean {
  let isCorrect: boolean = true
  const date = moment(value)
  if (!moment.isMoment(date)) {
    isCorrect = false
  }

  // Больше года, но меньше 17
  const diff = moment().diff(date, 'years')
  if (diff < 1 && diff > 17) {
    isCorrect = false
  }

  return this.optional(element) || isCorrect
}, 'Укажите верный возраст ребёнка')
